import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, KeyRound } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { applySocieteBranding } from "../hooks/useAppConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Activation d'un compte partenaire depuis le lien d'invitation (branding de la société). */
export default function PartnerAcceptPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/partners/invite/${token}`).then((r) => { setInfo(r.data); setName(r.data.name || ""); applySocieteBranding(r.data.branding); }).catch((e) => setErr(e.response?.data?.detail || "Invitation invalide"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setErr("8 caractères minimum"); return; }
    if (password !== confirm) { setErr("Les mots de passe ne correspondent pas"); return; }
    setLoading(true); setErr(null);
    try {
      await axios.post(`${API}/auth/partner-register`, { token, password, name }, { withCredentials: true });
      window.location.href = "/partner";
    } catch (e2) { setErr(e2.response?.data?.detail || "Erreur"); }
    setLoading(false);
  };

  const b = info?.branding || {};
  const primary = b.primary || "#f7c935";
  return (
    <div className="min-h-screen flex" style={{ background: b.background || "#0b0811" }} data-testid="partner-accept-page">
      <div className="hidden md:flex w-1/2 flex-col justify-end p-12" style={{ background: b.cover_url ? `url(${b.cover_url}) center/cover` : `radial-gradient(circle at 30% 20%, ${primary}55, transparent 55%)` }}>
        <div className="text-white text-4xl font-black leading-tight max-w-md">{b.welcome_title || "Bienvenue"}</div>
        <div className="text-slate-300 text-sm mt-3 max-w-md">{b.welcome_text}</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4">
          {b.logo_url ? <img src={b.logo_url} alt={b.app_name} className="h-10 object-contain" /> : <div className="text-xl font-black text-white">{b.app_name || "Blitzz"}</div>}
          {!info && !err && <Loader2 className="w-6 h-6 animate-spin" style={{ color: primary }} />}
          {info && (
            <>
              <div>
                <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: primary }}>Panel partenaire · {info.type_label}</div>
                <h1 className="text-2xl font-black text-white mt-1">Activez votre accès</h1>
                <p className="text-xs text-slate-400 mt-1">{info.societe_name} vous invite{info.company ? ` (${info.company})` : ""}. Identifiant : <b className="text-slate-200">{info.email}</b></p>
              </div>
              {info.status !== "invited" ? (
                <div className="text-sm text-amber-300" data-testid="partner-accept-used">Cette invitation a déjà été utilisée. <button type="button" className="underline" onClick={() => navigate("/login")}>Se connecter</button></div>
              ) : (
                <>
                  <Input placeholder="Votre nom" value={name} onChange={(e) => setName(e.target.value)} className="bg-white/5 border-white/10 text-white" data-testid="partner-accept-name" />
                  <Input type="password" placeholder="Mot de passe (8 caractères min.)" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white/5 border-white/10 text-white" data-testid="partner-accept-password" />
                  <Input type="password" placeholder="Confirmer le mot de passe" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-white/5 border-white/10 text-white" data-testid="partner-accept-confirm" />
                  <Button type="submit" disabled={loading} className="w-full font-black text-[#14101c]" style={{ background: primary }} data-testid="partner-accept-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <KeyRound className="w-4 h-4 mr-1" />} Créer mon accès</Button>
                </>
              )}
            </>
          )}
          {err && <div className="text-sm text-red-400" data-testid="partner-accept-error">{err}</div>}
          {b.footer_text && <div className="text-[10px] text-slate-500 pt-4">{b.footer_text}</div>}
        </form>
      </div>
    </div>
  );
}
